import { render, staticRenderFns } from "./order_info.vue?vue&type=template&id=23afb786&scoped=true"
import script from "./order_info.vue?vue&type=script&lang=js"
export * from "./order_info.vue?vue&type=script&lang=js"
import style0 from "./order_info.vue?vue&type=style&index=0&id=23afb786&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23afb786",
  null
  
)

export default component.exports